export const isEditorX = window.location.hostname.indexOf('editorx.com') !== -1;